import { Send, Pencil, Factory, Truck } from 'lucide-react';

const steps = [
  {
    icon: Send,
    number: "01",
    title: "Anfrage senden",
    description: "Teilen Sie uns Ihre Wünsche mit – per Formular, E-Mail oder Telefon."
  },
  {
    icon: Pencil,
    number: "02",
    title: "Design & Mock-up",
    description: "Wir erstellen Ihr Design und zeigen Ihnen eine realistische Vorschau."
  },
  {
    icon: Factory,
    number: "03",
    title: "Produktion",
    description: "Ihre Folien und Sticker werden in hoher Qualität produziert."
  },
  {
    icon: Truck,
    number: "04",
    title: "Versand",
    description: "Versandfertige Lieferung direkt zu Ihnen – zur Eigenanwendung."
  }
];

export const Process = () => {
  return (
    <section
      id="ablauf"
      className="py-24 lg:py-32 bg-white"
      data-testid="process-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-teal-50 text-teal-700 text-sm font-semibold rounded-full mb-4">
            ABLAUF
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 tracking-tight mb-4">
            So läuft's ab
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Klar, transparent und ohne Stress.
          </p>
        </div>

        {/* Steps - Desktop */}
        <div className="hidden lg:grid lg:grid-cols-4 gap-8 relative">
          {/* Connecting Line */}
          <div className="absolute top-12 left-[12.5%] right-[12.5%] h-0.5 bg-gradient-to-r from-teal-200 via-teal-400 to-teal-200" />
          
          {steps.map((step, index) => (
            <div
              key={index}
              className="relative flex flex-col items-center text-center"
              data-testid={`process-step-${index}`}
            >
              {/* Icon Circle */}
              <div className="relative z-10 w-24 h-24 bg-white border-4 border-teal-100 rounded-full flex items-center justify-center mb-6 shadow-lg">
                <div className="w-16 h-16 bg-teal-50 rounded-full flex items-center justify-center">
                  <step.icon className="w-8 h-8 text-teal-600" />
                </div>
              </div>
              
              {/* Number Badge */}
              <span className="absolute top-0 right-1/4 -translate-y-1/4 translate-x-1/2 w-8 h-8 bg-teal-600 text-white text-sm font-bold rounded-full flex items-center justify-center shadow-md">
                {step.number}
              </span>
              
              {/* Content */}
              <h3 className="text-xl font-bold text-slate-900 mb-2">
                {step.title}
              </h3>
              <p className="text-slate-600 leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>

        {/* Steps - Mobile */}
        <div className="lg:hidden space-y-8">
          {steps.map((step, index) => (
            <div
              key={index}
              className="relative flex gap-6"
              data-testid={`process-step-mobile-${index}`}
            >
              {/* Vertical Line */}
              {index < steps.length - 1 && (
                <div className="absolute left-8 top-20 bottom-0 w-0.5 bg-teal-100" />
              )}
              
              {/* Icon */}
              <div className="relative flex-shrink-0">
                <div className="w-16 h-16 bg-teal-50 border-2 border-teal-200 rounded-full flex items-center justify-center">
                  <step.icon className="w-7 h-7 text-teal-600" />
                </div>
                <span className="absolute -top-2 -right-2 w-7 h-7 bg-teal-600 text-white text-xs font-bold rounded-full flex items-center justify-center">
                  {step.number}
                </span>
              </div>
              
              {/* Content */}
              <div className="pt-2">
                <h3 className="text-lg font-bold text-slate-900 mb-1">
                  {step.title}
                </h3>
                <p className="text-slate-600">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
